import React, { useState, useEffect } from 'react';
import { useLanguage } from '../helpers/LanguageContext';
import { translations } from '../helpers/translations';
import { useCookieModal } from '../helpers/CookieContext';
import '../styles/CookieConsent.css';

const CookieConsent = () => {
    const { language } = useLanguage();
    const t = translations[language].cookieConsent;
    const { isCookieModalOpen, openCookieModal, closeCookieModal } = useCookieModal();

    const [customizing, setCustomizing] = useState(false);
    const [preferences, setPreferences] = useState({
        necessary: true,
        analytics: true,
        marketing: true
    });

    useEffect(() => {
        const storedPreferences = localStorage.getItem('cookiePreferences');
        if (!storedPreferences) {
            openCookieModal();
        } else {
            setPreferences(JSON.parse(storedPreferences));
        }
    }, [openCookieModal]);

    const savePreferences = (newPreferences) => {
        localStorage.setItem('cookiePreferences', JSON.stringify(newPreferences));
        setPreferences(newPreferences);
        closeCookieModal();
    };

    const handleAcceptAll = () => {
        savePreferences({
            necessary: true,
            analytics: true,
            marketing: true
        });
    };

    const handleRejectAll = () => {
        savePreferences({
            necessary: true,
            analytics: false,
            marketing: false
        });
    };

    const handleSaveCustom = () => {
        savePreferences(preferences);
    };

    const togglePreference = (key) => {
        if (key === 'necessary') return;
        setPreferences(prev => ({ ...prev, [key]: !prev[key] }));
    };

    if (!isCookieModalOpen) return null;

    return (
        <div className="cookie-consent-overlay">
            <div className="cookie-consent-container">
                <h2>{t.title}</h2>
                <p>{t.description}</p>

                {customizing && (
                    <div className="cookie-options">
                        <div className="cookie-option">
                            <div className="cookie-option-header">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={preferences.necessary}
                                        disabled
                                    />
                                    {t.necessary.title}
                                </label>
                            </div>
                            <p className="cookie-description">{t.necessary.description}</p>
                        </div>
                        <div className="cookie-option">
                            <div className="cookie-option-header">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={preferences.analytics}
                                        onChange={() => togglePreference('analytics')}
                                    />
                                    {t.analytics.title}
                                </label>
                            </div>
                            <p className="cookie-description">{t.analytics.description}</p>
                        </div>
                        <div className="cookie-option">
                            <div className="cookie-option-header">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={preferences.marketing}
                                        onChange={() => togglePreference('marketing')}
                                    />
                                    {t.marketing.title}
                                </label>
                            </div>
                            <p className="cookie-description">{t.marketing.description}</p>
                        </div>
                    </div>
                )}

                <div className="cookie-buttons">
                    {!customizing ? (
                        <>
                            <button className="cookie-btn accept" onClick={handleAcceptAll}>
                                {t.acceptAll}
                            </button>
                            <button className="cookie-btn reject" onClick={handleRejectAll}>
                                {t.rejectAll}
                            </button>
                            <button className="cookie-btn customize" onClick={() => setCustomizing(true)}>
                                {t.customize}
                            </button>
                        </>
                    ) : (
                        <>
                            <button className="cookie-btn accept" onClick={handleSaveCustom}>
                                {t.save}
                            </button>
                            <button className="cookie-btn cancel" onClick={() => setCustomizing(false)}>
                                Back
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
